import axios from "axios";

export const postPushMessage = async (message) => {
    const response = await axios.post("api/PushNotifications", message);
    const result = response.data;
    return result;
}